module.exports = __webpack_public_path__ + "static/media/flame.3c072db9.svg";